import React from 'react';
import { FlaskConical, Code, Lightbulb, ArrowRight, Play } from 'lucide-react';
import { Link } from 'react-router-dom';
import { t } from '../utils/translations';

const Lab = ({ language }) => {
  const features = [
    {
      icon: <FlaskConical size={24} />,
      title: t('lab.features.aiResearch.title', language),
      description: t('lab.features.aiResearch.description', language)
    },
    {
      icon: <Code size={24} />,
      title: t('lab.features.prototyping.title', language),
      description: t('lab.features.prototyping.description', language)
    },
    {
      icon: <Lightbulb size={24} />,
      title: t('lab.features.innovation.title', language),
      description: t('lab.features.innovation.description', language)
    }
  ];

  return (
    <div className="page-container">
      <div className="container">
        {/* 헤더 섹션 */}
        <div className="page-header">
          <h1 className="page-title">{t('lab.title', language)}</h1>
          <p className="page-subtitle">{t('lab.subtitle', language)}</p>
        </div>

        {/* 메인 콘텐츠 */}
        <div className="page-content">
          <div className="page-description">
            <p>{t('lab.description', language)}</p>
          </div>

          {/* 기능 카드들 */}
          <div className="section">
            <div className="grid grid-3">
              {features.map((feature, index) => (
                <div key={index} className="card" style={{ textAlign: 'center' }}>
                  <div className="icon">{feature.icon}</div>
                  <h3 style={{ fontSize: '1.3rem', fontWeight: 600, marginBottom: '1rem', color: 'inherit' }}>
                    {feature.title}
                  </h3>
                  <p style={{ lineHeight: '1.6', color: 'inherit' }}>{feature.description}</p>
                </div>
              ))}
            </div>
          </div>

          {/* 현재 프로젝트 섹션 */}
          <div className="section">
            <h2 className="section-title">
              {t('lab.currentProjects', language)}
            </h2>
            <div className="grid grid-2">
              <Link to="/youtube-player" className="card project-link-card">
                <div className="icon">
                  <Play size={32} />
                </div>
                <h3 style={{ fontSize: '1.4rem', fontWeight: 600, marginBottom: '1rem', color: 'inherit' }}>
                  {t('lab.youtubePlayer.title', language)}
                </h3>
                <p style={{ lineHeight: '1.6', color: 'inherit', marginBottom: '1.5rem' }}>
                  {t('lab.youtubePlayer.description', language)}
                </p>
                <div className="tags">
                  <span className="tag" style={{ 
                    backgroundColor: '#667eea15', 
                    color: '#667eea',
                    borderColor: '#667eea30'
                  }}>
                    {t('lab.youtubePlayer.category', language)}
                  </span>
                  <span className="tag" style={{ 
                    backgroundColor: '#4ecdc415', 
                    color: '#4ecdc4',
                    borderColor: '#4ecdc430'
                  }}>
                    {t('lab.youtubePlayer.type', language)}
                  </span>
                  <span className="tag" style={{ 
                    backgroundColor: '#ff6b6b15', 
                    color: '#ff6b6b',
                    borderColor: '#ff6b6b30'
                  }}>
                    {t('lab.youtubePlayer.status', language)}
                  </span>
                </div>
              </Link>
            </div>
          </div>

          {/* Coming Soon 섹션 */}
          <div className="section">
            <div className="gradient-card">
              <h2>{t('lab.comingSoon.title', language)}</h2>
              <p>{t('lab.comingSoonMessage', language)}</p>
              <div className="feature-list">
                <div className="feature-item">
                  <ArrowRight size={16} />
                  <span>{t('lab.comingSoon.portfolio', language)}</span>
                </div>
                <div className="feature-item">
                  <ArrowRight size={16} />
                  <span>{t('lab.comingSoon.research', language)}</span>
                </div>
                <div className="feature-item">
                  <ArrowRight size={16} />
                  <span>{t('lab.comingSoon.blog', language)}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Lab;
